import FolderIcon from "../../../../../assets/icons/FolderIcon";
import "./FolderItem.scss";

import { useNavigate } from "react-router";
import { shortenName } from "./nameUtils";
import { linkToNewChatFolder } from "../../../../../routes";
import { useParams } from "react-router-dom";

const FolderItem = ({ chat }) => {
  const nav = useNavigate();
  const { workspaceId } = useParams();
  return (
    <div
      className="chat_list_item"
      onClick={() => nav(linkToNewChatFolder(workspaceId, chat.uid))}
    >
      <div className="item_icon">
        <FolderIcon color="rgb(145,155,173)" size={48} strokeWidth="1.5" />
        {/*<FileTextIcon color="rgb(145,155,173)" size={36} strokeWidth="1.5" />*/}
      </div>
      <div className="item_name">{shortenName(chat.name)}</div>
    </div>
  );
};

export default FolderItem;
